import { useEffect, useRef, useState, type ReactNode } from "react";
import { privacyEmail } from "../../../shared/legal";

/** A numbered clause: the plain-English summary beside the formal text. */
export function Clause({
  n,
  id,
  title,
  short,
  first,
  tight,
  children,
}: {
  n: string;
  id: string;
  title: string;
  short: string;
  first?: boolean;
  tight?: boolean;
  children: ReactNode;
}) {
  const cls = ["lg-clause", first ? "lg-clause--first" : "", tight ? "lg-clause--tight" : ""].filter(Boolean).join(" ");
  return (
    <article className={cls} id={id}>
      <div className="lg-side">
        <div className="lg-num">{n}</div>
        <h3>{title}</h3>
        <div className="lg-short">
          <b>IN SHORT</b>
          <span>{short}</span>
        </div>
      </div>
      <div className="lg-text">{children}</div>
    </article>
  );
}

/** A table row: what, who or why, and for how long. Cells stack on a phone. */
export function Row({ a, b, c }: { a: ReactNode; b: ReactNode; c: ReactNode }) {
  return (
    <div className="lg-row" role="listitem">
      <div className="lg-c1">{a}</div>
      <div className="lg-c2">{b}</div>
      <div className="lg-c3">{c}</div>
    </div>
  );
}

export function Label({ children }: { children: ReactNode }) {
  return <span className="lg-lab">{children}</span>;
}

export function Chips({ items }: { items: string[] }) {
  return (
    <>
      {items.map((t) => (
        <span className="lg-chip" key={t}>
          {t}
        </span>
      ))}
    </>
  );
}

/** A button that turns into the privacy email link when clicked, so scrapers never see the address. */
export function PrivacyMail() {
  const [address, setAddress] = useState<string | null>(null);
  const link = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    if (address) link.current?.focus();
  }, [address]);
  if (address) {
    return (
      <a ref={link} href={`mailto:${address}`}>
        {address}
      </a>
    );
  }
  return (
    <button type="button" className="lg-reveal" onClick={() => setAddress(privacyEmail())}>
      Reveal email address
    </button>
  );
}
